const APPLICATION = {
  hb3: {
    id: 1,
    name: 'HB3',
  },
};

const CUSTOM_BOOLEAN = {
  True: {
    string: 'T',
    numeric: 1,
  },
  False: {
    string: 'F',
    numeric: 0,
  },
};

export class SupportCode {
  private platformId = APPLICATION.hb3.id;
  private supportCode = '';

  constructor(
    private isLoremUser: boolean,
    private isLoremContract: boolean,
    private isDiscretional: boolean,
    private hasL2: boolean,
    private contractID: string = '',
    private isReadOnly: boolean,
    private isReadOnlyByRelationship: boolean,
  ) {
    this.supportCode = [isLoremUser, isLoremContract, isDiscretional, hasL2]
      .map((value, index) => {
        const isOdd = index % 2;
        const booleanKey = value ? 'True' : 'False';
        return isOdd
          ? CUSTOM_BOOLEAN[booleanKey].numeric
          : CUSTOM_BOOLEAN[booleanKey].string;
      })
      .join('');
  }

  getCode() {
    const generatedCode = [this.platformId, this.supportCode];
    return generatedCode.join('');
  }

  getTrackingObject() {
    const code = [this.getCode(), this.contractID].join('-');
    return {
      startedTime: new Date(),
      code,
      platform: APPLICATION.hb3.name,
      isLoremUser: this.isLoremUser,
      isLoremContract: this.isLoremContract,
      isDiscretional: this.isDiscretional,
      hasL2: this.hasL2,
      isReadOnly: this.isReadOnly,
      isReadOnlyByRelationship: this.isReadOnlyByRelationship,
    };
  }
}
